/* eslint-disable max-len */
import React from "react";

interface SVGRProps {
    title?: string;
    titleId?: string;
}

export const SvgIconLocation2Shape: React.FC<React.SVGProps<SVGSVGElement> & SVGRProps> = ({ title, titleId, ...props }) => (
    <svg width="1em" height="1em" viewBox="0 0 20 24" aria-labelledby={titleId} {...props}>
        {title ? <title id={titleId}>{title}</title> : null}
        <path
            d="M10 .934c5.134 0 9.295 4.201 9.295 9.383 0 7.714-6.546 9.902-9.295 13.634C7.322 20.204.705 18.42.705 10.317.705 5.135 4.866.934 10 .934zm0 4.497c-2.727 0-4.938 2.187-4.938 4.886 0 2.698 2.211 4.886 4.938 4.886s4.938-2.188 4.938-4.886c0-2.699-2.211-4.886-4.938-4.886z"
            fillRule="evenodd"
        />
    </svg>
);
